import * as React from 'react'
import { useNavigate } from 'react-router-dom'
import AppBar from '@mui/material/AppBar'
import Box from '@mui/material/Box'
import Toolbar from '@mui/material/Toolbar'
import IconButton from '@mui/material/IconButton'
import { BASEDIR } from 'constants'

import Container from '@mui/material/Container'

import LanguageSwitcher from 'components/LanguageSwitcher'
import SettingsButton from 'components/SettingsButton'
import ToggleThemeButton from 'components/ToggleThemeButton'

function Header() {
  const navigate = useNavigate()

  return (
    <AppBar position="static">
      <Container maxWidth="lg">
        <Toolbar disableGutters>
          {/* LOGO -------- */}
          <IconButton
            size="large"
            edge="start"
            color="inherit"
            aria-label="menu"
            sx={{ mr: 2, pt: 0, pb: 0, display: { xs: 'none', md: 'flex' } }}
            onClick={() => navigate('/')}
          >
            <img
              src={`${BASEDIR}/logo_AraPicTalk_texto_blanco v2.png`}
              style={{ height: '40px', weight: 'auto' }}
              alt="Logitipo Arawrite"
            />
          </IconButton>

          {/* MOBILE DISPLAY -------- */}
          <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
            <IconButton
              size="large"
              edge="start"
              color="inherit"
              aria-label="menu"
              sx={{ ml: 0, pt: 0, pb: 0, display: { xs: 'flex', md: 'none' } }}
              onClick={() => navigate('/')}
            >
              <img
                src={`${BASEDIR}/logo_AraPicTalk_texto_blanco v2.png`}
                style={{ height: '40px', weight: 'auto' }}
                alt="Logitipo Arawrite"
              />
            </IconButton>
          </Box>

          {/* PC DISPLAY -------- */}
          <Box
            sx={{
              display: 'flex',
              flexGrow: 1,
              mr: 0,
              justifyContent: 'flex-end',
            }}
          >
            {/* Reusable Toggle Theme Button */}
            <ToggleThemeButton />

            {/* Reusable Settings Button */}
            <SettingsButton />
          </Box>
          <LanguageSwitcher />
        </Toolbar>
      </Container>
    </AppBar>
  )
}

export default Header
